import pluralNumber from '~/app/utils/pluralNumber';

export const initCompilation = () => {
	const timer = document.querySelector( 'section.promo-form div.timer, div.popup div.timer' );

	if ( !timer )
	{
		return;
	}

	const deadline = new Date( timer.dataset.deadline );

	if ( isNaN( deadline ) )
	{
		if ( timer.querySelector( 'p' ) )
		{
			timer.querySelector( 'p' ).innerHTML = timer.querySelector( 'p' ).dataset.empty;
		}

		timer.querySelector( 'ul' ).innerHTML = '';

		return;
	}

	const updateTimer = () => {
		const current = new Date();
		const diff = deadline.getTime() - current.getTime();

		if ( diff < 0 )
		{
			if ( timer.querySelector( 'p' ) )
			{
				timer.querySelector( 'p' ).innerHTML = timer.querySelector( 'p' ).dataset.empty;
			}

			timer.querySelector( 'ul' ).innerHTML = '';

			return;
		}

		const days = Math.floor( diff / 1000 / 60 / 60 / 24 );

		if ( days > 0 )
		{
			timer.querySelector( 'li.days' ).innerHTML = `<strong>${days > 9 ? `${days}` : `0${days}`}</strong><span>${pluralNumber( days, 'день', 'дня', 'дней' )}</span>`;
		}
		else
		{
			timer.querySelector( 'li.days' ).style.display = 'none';
		}
		
		const hours = Math.floor( diff / 1000 / 60 / 60 ) - days * 24;

		timer.querySelector( 'li.hours' ).innerHTML = `<strong>${hours > 9 ? `${hours}` : `0${hours}`}</strong><span>${pluralNumber( hours, 'час', 'часа', 'часов' )}</span>`;
		
		const minutes = Math.floor( diff / 1000 / 60 ) - days * 24 * 60 - hours * 60;

		timer.querySelector( 'li.minutes' ).innerHTML = `<strong>${minutes > 9 ? `${minutes}` : `0${minutes}`}</strong><span>мин.</span>`;

		const seconds = Math.floor( diff / 1000 ) - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

		timer.querySelector( 'li.seconds' ).innerHTML = `<strong>${seconds > 9 ? `${seconds}` : `0${seconds}`}</strong><span>сек.</span>`;
	};

	updateTimer();
	setInterval( updateTimer, 1000 );
};


//////////////////
// WEBPACK FOOTER
// ./app/Common/Compilation/index.js
// module id = dXIo
// module chunks = 12